import { render, staticRenderFns } from "./ChangePlan.vue?vue&type=template&id=a0836fe2"
import script from "./ChangePlan.vue?vue&type=script&lang=js"
export * from "./ChangePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports